import { render, staticRenderFns } from "./breadcrumb-comp.vue?vue&type=template&id=84b88d22&scoped=true&class=pt-0&"
import script from "./breadcrumb-comp.vue?vue&type=script&lang=js&"
export * from "./breadcrumb-comp.vue?vue&type=script&lang=js&"
import style0 from "./breadcrumb-comp.vue?vue&type=style&index=0&id=84b88d22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b88d22",
  null
  
)

export default component.exports